import { Typography } from '@mui/material';
import LcElemensCards from '../../../../../card/LcElemensCards';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import PaperBase from '../../../../../Paper/PaperBase';
import { useGroupStudentsContext } from '../GroupStudentsContext/GroupStudentsContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserChip from '../../../../../chip/UserChip';

const DialogStudentDistribution = ({ show, onClose, formData = {} }) => {
  const { currentCurriculum } = useGroupStudentsContext();
  return (
    <DialogConfirmCancel
      id={`student-distribution-${formData?._id}`}
      open={show}
      onCancel={onClose}
      title='Student Distribution'
      onCloseHeader={true}
      showActions={false}
      maxWidth='md'
    >
      <div className='flex flex-col w-full gap-1'>
        <LcElemensCards
          lcs={formData.lcs}
          currentCurriculum={currentCurriculum}
          width='min-w-120px max-w-120px'
        />
        <div className='flex flex-nowrap w-full gap-1'>
          <PaperBase
            className={'font-bold min-w-120px max-w-120px bg-muted text-muted-foreground'}
            children={formData.levelName}
          />
          <PaperBase
            className={'min-w-200px w-full text-ellipsis bg-muted text-muted-foreground'}
            children={<Typography className='text-ellipsis text-sm'>{formData.levelDefinition}</Typography>}
          />
        </div>
        <div className='flex flex-nowrap w-full gap-1'>
          <PaperBase
            className={'font-bold min-w-120px max-w-120px bg-muted text-muted-foreground'}
            children='Marked'
          />
          <PaperBase
            className={'min-w-200px w-full text-ellipsis bg-muted text-muted-foreground'}
            children={
              <div className='text-xs flex gap-1 items-center justify-center rounded'>
                <div
                  style={{
                    width: 15,
                    height: 15,
                    backgroundColor: formData.markingPrimaryColor,
                    border: `1px solid ${formData.markingSecondaryColor}`
                  }}
                />
                <span className='text-sm'>{formData.markingName}</span>
              </div>
            }
          />
        </div>
                <div className='flex flex-nowrap w-full gap-1'>
          <PaperBase
            className={'font-bold min-w-120px max-w-120px bg-muted text-muted-foreground'}
            children='Percentage'
          />
          <PaperBase
            className={'min-w-200px w-full text-ellipsis bg-muted text-muted-foreground'}
            children={
              `${formData.percentage ? formData.percentage.toFixed(2) : 0}%`
            }
          />
        </div>
        <PaperBase
          className={'font-bold bg-muted-foreground text-muted'}
          children={`Students (${formData?.students?.length || 0})`}
        />
        <div className='grid grid-cols-5 gap-1 max-h-screen-1/2 overflow-y-auto'>
          {formData?.students?.length > 0 ? (
            formData.students.map((item, index) => (
              <UserChip
                key={index}
                id={item.id}
                code={item.code}
                name={item.fullName}
                photo={item.photo}
                maxWidth='160px'
                className='mb-2 '
              />
            ))
          ) : (
            <Typography className='p-2 text-sm col-span-full flex items-center justify-center opacity-75'>
              No students found for this distribution.
            </Typography>
          )}
        </div>
      </div>
    </DialogConfirmCancel>
  );
};

export default DialogStudentDistribution;
